














































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import User from "../../../store/entities/user";
@Component
export default class CreateUser extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  user: User = new User();
  idisable:boolean = false;
  get roles() {
    return this.$store.state.user.roles;
  }
  get company() {
    return this.$store.state.company.list;
  }
  save() {
    (this.$refs.userForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.idisable = true
        await this.$store.dispatch({
          type: "user/create",
          data: this.user,
        });
        (this.$refs.userForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
         setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
      }
    });
  }
  cancel() {
    (this.$refs.userForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  validatePassCheck = (rule: any, value: any, callback: any) => {
    if (!value) {
      callback(new Error("两次输入的密码不相同"));
    } else if (value !== this.user.password) {
      callback(new Error("两次输入的密码不相同"));
    } else {
      callback();
    }
  };
  userRule = {
    userName: [
      {
        required: true,
        message: "请填写用户名",
        trigger: "blur",
      }
    ],
    name: [
      {
        required: true,
        message: "请填写姓名",
        trigger: "blur",
      }
    ],
    phoneNumber: [
      {
        required: true,
        message: "请填写手机号",
        trigger: "blur",
      }
    ],
    emailAddress: [
      {
        required: true,
        message: "请填写邮箱地址",
        trigger: "blur",
      },
      { type: "email" },
    ],
    password: [
      {
        required: true,
        message: "请填写密码",
        trigger: "blur",
      },
      {
        pattern:/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/,
        message:"密码强度低!必须由大小写字母和数字或特殊字符三种及以上组合!(长度8位以上)",
        trigger:"blur",
      }
    ],
     cId: [
      {
        type: "number",
        required: true,
        message: "请选择所属公司",
        trigger: "change",
      }
    ],
    confirmPassword: [
      { validator: this.validatePassCheck, trigger: "blur" },
      {
        pattern:/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/,
        message:"密码强度低!必须由大小写字母和数字或特殊字符三种及以上组合!(长度8位以上)",
        trigger:"blur",
      }
    ]
  };
}
